import Error403PageConfig from './403/Error403PageConfig';
import Error404PageConfig from './404/Error404PageConfig';
import Error500PageConfig from './500/Error500PageConfig';
import i18next from 'i18next';
import enGB from '@locales/errors/enGB';
import deAT from '@locales/errors/deAT';

i18next.addResourceBundle('enGB', 'errorPages', enGB);
i18next.addResourceBundle('deAT', 'errorPages', deAT);

const errorConfigs = [
	Error403PageConfig,
	Error404PageConfig,
	Error500PageConfig
];

export default errorConfigs;